import { formatNumber } from "@";

export const fillPieChart = (data) => {
  if (!data) return [];

  const values = Object.entries(data).map(([key, value]) => ({
    name: key,
    value: parseFloat(formatNumber(value.toFixed(1))),
  }));

  const allValuesZero = (data) => data.every((item) => item.value === 0);

  return allValuesZero(values) ? [] : values;
};
